import React from 'react';
import ReactDOM from 'react-dom';
import {SliderFront} from './modules/sliders/slider-front';
import {SliderPanel} from './modules/sliders/slider-panel';
import {SliderShortcode} from './modules/sliders/slider-shortcode';
import {ImageGrid} from './modules/imagegrid';
import {base64Decode} from './modules/utils/base64Decode';
import {Sticky} from './modules/sticky';
import {ToggleMenu} from './lib/toggle-menu';
import {ToggleHover} from './lib/toggle-hover';
import {ToggleSearch} from './modules/toggle-search';
import {LoadMore} from './modules/load-more';
import {popupLinks} from './modules/popup-links';

var $ = require('jquery');
var Shariff = require('shariff');


// Breakpoints
const breakpoints = {
  navigation: window.matchMedia( "(min-width: 1000px)" )
};

function setNavigationClass(bp) {
  if (bp.matches) {
    document.body.classList.add('navigation-desktop');
    document.body.classList.remove('navigation-mobile');
  } else {
    document.body.classList.add('navigation-mobile');
    document.body.classList.remove('navigation-desktop');
  }
}
setNavigationClass(breakpoints.navigation);
breakpoints.navigation.addListener(setNavigationClass);


// Sticky Navigation
const sticky = new Sticky("site-header", "site-content");


// Menu Toggle
const menuToggle = new ToggleMenu("site-navbar-toggle", "navbar-active");


// Navigation Hover
const siteMenuItems = document.querySelectorAll('.site-menu .cat-item');
Array.prototype.forEach.call(
  siteMenuItems,
  (item) => {
    const itemHover = new ToggleHover(item, 'item-active')
  }
);

// Search Toggle
const toggeSearch = new ToggleSearch("site-search", "search-field", "search-active", "search-submit");


// Sliders & Imagegrid
const elemSliderFront = document.querySelector('#react-slider-front');
if(elemSliderFront) {
  const sliderFrontData = JSON.parse(base64Decode(elemSliderFront.dataset.slider));
  ReactDOM.render(<SliderFront sliderdata={sliderFrontData}/>, elemSliderFront);
}

const elemSliders = document.querySelectorAll('.react-slider-panel');
if(elemSliders.length > 0) {
  Array.prototype.forEach.call(
    Array.from(elemSliders),
    (elemSlider) => {
      const sliderData = JSON.parse(base64Decode(elemSlider.dataset.slider));
      ReactDOM.render(<SliderPanel sliderdata={sliderData}/>, elemSlider);
    }
  );
}

const elemImageGrids = document.querySelectorAll('.entry-imagegrid');
if(elemImageGrids.length > 0) {
  Array.prototype.forEach.call(
    Array.from(elemImageGrids),
    (elemImageGrid) => {
      const imagegridData = JSON.parse(base64Decode(elemImageGrid.dataset.imagegrid));
      ReactDOM.render(<ImageGrid items={imagegridData.items} itemsTotal={imagegridData.itemsTotal}/>, elemImageGrid);
    }
  );
}

const elemEntrySliders = document.querySelectorAll('.entry-slider');
if(elemEntrySliders.length > 0) {
  Array.prototype.forEach.call(
    Array.from(elemEntrySliders),
    (elemEntrySlider) => {
      const sliderData = JSON.parse(base64Decode(elemEntrySlider.dataset.slider));
      ReactDOM.render(<SliderShortcode items={sliderData} />, elemEntrySlider);
    }
  );
}


// Load more articles
const loadMore = new LoadMore(document.querySelector('.load-more'), document.getElementById("content"));

// youtube
function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

const ytFrames = document.querySelectorAll('iframe[src^="https://www.youtube.com"]');
Array.prototype.forEach.call(
  ytFrames,
  (frame) => {
    let jsVideo = document.createElement('div')
    jsVideo.className = 'js-video'
    wrap(frame, jsVideo)
  }, ytFrames
)

// vimeo
const vimFrames = document.querySelectorAll('iframe[src^="https://player.vimeo.com"]');
Array.prototype.forEach.call(
  vimFrames,
  (frame) => {
    let jsVideo = document.createElement('div')
    jsVideo.className = 'js-video vimeo'
    wrap(frame, jsVideo)
  }, vimFrames
)

const PopupLinks = new popupLinks('data-rel', 'popup')

// shariff
const socialLinks = $('.social-links');
if(socialLinks.length) {
  new Shariff($(socialLinks));
}
